module.exports = __webpack_public_path__ + "static/media/gts26.0e6820b4.png";